import template from "./proxy-response-window.html";
function Controller($window, toastr) {
	const ctrl = this;

	ctrl.$onInit = () => {
		const name = ctrl.filename || "ProxyWindow";
		const popup = $window.open("", name);

		if(!popup) {
			if(toastr && typeof toastr.warning === "function") {
				toastr.warning("VESL was unable to open a new window. Please enable pop-ups for this site.");
			}
			ctrl.opened = false;
			return;
		}

		try {
			popup.document.open();
			popup.document.write(ctrl.content || "");
			popup.document.close();
			ctrl.opened = true;
		}catch(e) {
			ctrl.opened = false;
			if(toastr && typeof toastr.error === "function") {
				toastr.error("Failed to write content to the new window.");
			}
		}
	};
}
Controller.$inject = ["$window", "toastr"];

export default angular.module("vesl.components.proxy-response-window", []).component("proxyResponseWindow", {
	bindings: {
		content: "<",
		filename: "<"
	},
	controller: Controller,
	template
}).name;
